import { Component, OnInit, Input, OnChanges, AfterViewInit } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { Validators, FormControl } from '@angular/forms';
import * as fieldValidators from 'src/app/shared/reactive-validators/fields.validator';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-postal-field[formGroup][propertyName][countryValue]',
  templateUrl: './postal-field.component.html',
  styles: [],
  standalone: false,
})
export class PostalFieldComponent extends BaseFormComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() countryValue: string;

  @Input() maxLength?: number;
  @Input() required? = true;
  @Input() FIELD_SPACING: number;
  @Input() regular?: boolean;

  postalCode: string;
  private currentValue: string;

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  ngOnInit() {
    if ( this.propertyId == null ) {
      this.propertyId = 'postalCode';
    }
    if ( this.maxLength == null ) {
      this.maxLength = 10; // Default length for CA and US (Q1Q-Q1Q and 12345-1234)
    }

    this.setLabel();
    this.setValidators();
  }

  ngOnChanges() {
    this.setLabel();
    this.setValidators();
  }

  ngAfterViewInit() {
    this.formGroup.get(this.propertyName).setValue(this.currentValue);
    this.formGroup.controls[this.propertyName].updateValueAndValidity();
  }

  setLabel() {
    if ( this.countryValue === 'CA' ) {
      this.label = 'Postal code';
    } else if ( this.countryValue === 'US' ) {
      this.label = 'ZIP Code';
    }
  }

  setValidators() {
    if ( this.countryValue == null ) { return; }

    this.formGroup.controls[this.propertyName].clearValidators();
    if ( this.required ) {
      if ( this.countryValue === 'CA' ) {
        this.formGroup.controls[this.propertyName].setValidators([Validators.required, fieldValidators.postalCodeValidator('CA')]);
      } else if ( this.countryValue === 'US' ) {
        this.formGroup.controls[this.propertyName].setValidators([Validators.required, fieldValidators.postalCodeValidator('US')]);
      }
    } else {
      if ( this.countryValue === 'CA' ) {
        this.formGroup.controls[this.propertyName].setValidators([fieldValidators.postalCodeValidator('CA')]);
      } else if ( this.countryValue === 'US' ) {
        this.formGroup.controls[this.propertyName].setValidators([fieldValidators.postalCodeValidator('US')]);
      }
    }

    this.formGroup.controls[this.propertyName].updateValueAndValidity();

    if ( this.formGroup.get(this.propertyName).invalid ) {
      this.currentValue = '';
      this.formGroup.get(this.propertyName).setValue('');
    } else {
      this.currentValue = this.formGroup.get(this.propertyName).value;
    }

  }

  // Format Canadian postal code as Q1Q Q1Q
  formatPostalCode(event: any) {
    if ( this.countryValue == null ) { return; }

    let input = event.target.value;
    if ( this.countryValue === 'CA' ) {
      input = input.replace(/ /g, '');
      if ( input.length > 3 ) {
        input = input.slice(0, 3) + ' ' + input.slice(3);
      } else {
        input = input.slice(0, 3);
      }      
      this.formGroup.controls[this.propertyName].setValue(input.toLocaleUpperCase());
    }
  }

}
